export type ScoreCard = {nickname: string; week: string; score: number; correct: number; handled: number};

// A local image built from the confirmed result. No answers or account data.
export async function createScoreCard(result: ScoreCard): Promise<File> {
  const canvas = document.createElement('canvas');
  canvas.width = 1200;
  canvas.height = 630;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas unavailable');
  ctx.fillStyle = '#15201a';
  ctx.fillRect(0, 0, 1200, 630);
  ctx.fillStyle = '#f6f7ee';
  ctx.font = 'bold 38px system-ui, sans-serif';
  ctx.fillText('fraud attacks', 64, 82);
  ctx.fillStyle = '#c1d1c4';
  ctx.font = '24px monospace';
  ctx.fillText(`SCAM RUSH / WEEK OF ${result.week}`, 64, 148);
  ctx.fillStyle = '#c3e7b5';
  ctx.font = 'bold 146px system-ui, sans-serif';
  ctx.fillText(result.score.toLocaleString('en-US'), 56, 330, 1040);
  ctx.fillStyle = '#f6f7ee';
  ctx.font = '32px system-ui, sans-serif';
  ctx.fillText(`${result.nickname.slice(0, 24)} · ${result.correct} correct · ${result.handled} handled`, 64, 404, 1072);
  ctx.strokeStyle = '#5b7060';
  ctx.beginPath(); ctx.moveTo(64, 465); ctx.lineTo(1136, 465); ctx.stroke();
  ctx.font = 'bold 36px system-ui, sans-serif';
  ctx.fillText('Same inbox. Your turn.', 64, 542);
  ctx.font = '24px monospace';
  ctx.fillText('fraudattacks.com', 870, 542);
  const blob = await new Promise<Blob>((resolve, reject) => canvas.toBlob(value => value ? resolve(value) : reject(new Error('Image unavailable')), 'image/png'));
  return new File([blob], `scam-rush-${result.week}.png`, {type: 'image/png'});
}

export function downloadScoreCard(file: File) {
  const url = URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = url; link.download = file.name;
  document.body.append(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
